import { connect } from 'react-redux';
import OutreachAggSearchForm from '../../components/OutreachAggSearchForm';
import { updateOutreachAggregateReportQuery } from '../../redux/actions/report';
import { OUTREACH_AGGREGATE } from '../../helpers/ReportTemplateTypes';
import {
  getReportTemplatesByFileType,
  getIsFetching
} from '../../redux/selectors/report-template';
import { fetchReportTemplates } from '../../redux/sagas/routines';

function mapStateToProps(state) {
  return {
    ...state,
    isFetchingTemplates: getIsFetching(state),
    templates: getReportTemplatesByFileType(state, OUTREACH_AGGREGATE)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchReportTemplates({ qs: { fileType: OUTREACH_AGGREGATE } }));
    },
    updateSearchQuery: query => {
      dispatch(updateOutreachAggregateReportQuery(query));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutreachAggSearchForm);
